module.exports = __webpack_public_path__ + "img/topup-header_m_no_diamond.a60bd7e4.png";